import { useDeleteAlarmTypeGroup } from '@hakimo-ui/hakimo/data-access';
import { AlarmTypeGroup } from '@hakimo-ui/hakimo/types';
import { eventTracker, toast } from '@hakimo-ui/hakimo/util';
import { Alert, Button, Modal } from '@hakimo-ui/shared/ui-base';

interface Props {
  alarmTypeGroup: AlarmTypeGroup;
  onClose: () => void;
}

export function DeleteAlarmTypeGroup(props: Props) {
  const { alarmTypeGroup, onClose } = props;
  const onSuccess = () => {
    toast('Alarm Type Group Deleted', { type: 'success' });
    onClose();
  };

  const deleteAlarmTypeGroupMutation = useDeleteAlarmTypeGroup(
    alarmTypeGroup.alarmTypeGroupId,
    onSuccess
  );

  const onSubmit = () => {
    deleteAlarmTypeGroupMutation.mutate({});
  };

  const actions = (
    <>
      <Button
        variant="error"
        onClick={onSubmit}
        disabled={deleteAlarmTypeGroupMutation.isLoading}
        onSideEffect={eventTracker('submit_delete_alarm_type_group')}
        loading={deleteAlarmTypeGroupMutation.isLoading}
      >
        Delete
      </Button>
      <Button
        onClick={onClose}
        onSideEffect={eventTracker('cancel_delete_alarm_type_group')}
      >
        Cancel
      </Button>
    </>
  );

  return (
    <Modal
      title="Delete Alarm Type Group"
      open
      onClose={onClose}
      footer={actions}
    >
      {deleteAlarmTypeGroupMutation.isError && (
        <div className="mt-4 px-8">
          <Alert type="error">
            {deleteAlarmTypeGroupMutation.error.message}
          </Alert>
        </div>
      )}
      <div className="w-[34rem] space-y-4 p-8">
        <p>
          Are you sure you want to delete the alarm type group{' '}
          <b>{alarmTypeGroup.name}</b>? It will also be removed from the users
          it is assigned to.
        </p>
      </div>
    </Modal>
  );
}

export default DeleteAlarmTypeGroup;
